import { Box, FormControlLabel, Link, Typography } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import TaxGuruDialog from "./TaxGuruDialog";
import Image from "mui-image";
import { useTranslation } from "react-i18next";
import useIAmAccountant from "../modules/accountant/function/useIAmAccountant";
import useDebounce from "../hook/useDebounce";
import { useTaxSelector } from "../redux/general/reduxStore";
import { bulkSaveSimplePreferences, findPreferences } from "../backend/taxguru/client/jmf/corePreferencesClient";
import Checkbox from "@mui/material/Checkbox";
import useDialogState from "./hook/useDialogState";
import ComputerIcon from "@mui/icons-material/Computer";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import IosShareIcon from "@mui/icons-material/IosShare";

const WelcomeModal = () => {
    const { t } = useTranslation();
    const { isAccountant, accountant } = useIAmAccountant();
    // The onboarding dialog goes first, the welcome dialog is shown once it is filled in.
    const onboardingRequired = !!accountant?.onboardingRequired;
    const { open, onOpen, onClose } = useDialogState();
    const [isChecked, setIsChecked] = React.useState(true);
    const userId = useTaxSelector((state) => state.user.userId);

    const debounceChecked = useDebounce(isChecked, 1000);
    const handleChange = () => setIsChecked((prevState) => !prevState);
    useEffect(() => {
        if (isAccountant && userId && !onboardingRequired) {
            findPreferences(["SHOW-WELCOME-DIALOG"], userId).then(async (value) => {
                const keys = value.data.data;
                if (keys?.[0]?.simpleValue !== undefined) {
                    const showModalByPreference = keys[0].simpleValue === "true";
                    if (showModalByPreference) {
                        onOpen();
                    }
                    setIsChecked(!showModalByPreference);
                } else {
                    onOpen();
                }
            });
        }
    }, [isAccountant, onOpen, userId, onboardingRequired]);

    useEffect(() => {
        if (userId && open) {
            bulkSaveSimplePreferences([["SHOW-WELCOME-DIALOG", (!debounceChecked).toString()]], userId);
        }
    }, [debounceChecked, open, userId]);
    const buttonLinks = [
        {
            text: t("welcomeDialog.links.buttons.aboutWebApp"),
            link: "https://www.youtube.com/watch?v=eswICkeNSpc&list=PL7Q5NKR8JIELM95pjbz_O_p-spjRDGuOM",
            icon: <ComputerIcon sx={{ width: "100%", height: "100%" }} />,
        },
        {
            text: t("welcomeDialog.links.buttons.aboutMobileApp"),
            link: "https://www.youtube.com/watch?v=JDhoRzLeVbs&list=PL7Q5NKR8JIEIFtIJKLpwTGGiTmFYIEou4",
            icon: <PhoneIphoneIcon sx={{ width: "100%", height: "100%" }} />,
        },
        {
            text: t("welcomeDialog.links.buttons.aboutIntegrationToSW"),
            link: "https://www.youtube.com/watch?v=PB01XPvtgXc&list=PL7Q5NKR8JIEJwfjhKwoP0kTdv7PAs3M8t",
            icon: <IosShareIcon sx={{ width: "100%", height: "100%" }} />,
        },
    ];

    return (
        <TaxGuruDialog onClose={onClose} open={open}>
            <Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.4 }}>
                    <Typography variant={"h6"} sx={{ marginBottom: 1.4 }}>
                        {t("welcomeDialog.title")}
                    </Typography>
                    <Typography variant={"subtitle1"}>{t("welcomeDialog.wantToKnowMore")}</Typography>
                    <Typography variant="subtitle1">
                        {t("welcomeDialog.preparedForYou")}{" "}
                        <Link href={"https://dokladovna.cz/otazky-a-odpovedi/"} target={"_blank"}>
                            {t("welcomeDialog.links.answersForQuestions")}
                        </Link>{" "}
                        {t("welcomeDialog.andVideos")}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        flexDirection: "column",
                        marginY: 0.8,
                        gap: 1.4,
                        marginTop: 2,
                        alignItems: "flex-start",
                    }}
                >
                    {buttonLinks.map((button) => {
                        return (
                            <Link href={button.link} sx={{ display: "flex", alignItems: "center", gap: 1 }} target={"_blank"} key={button.text}>
                                <Box sx={{ height: 28, width: 28, display: "flex", justifyContent: "flex-start" }}>{button.icon}</Box>
                                {button.text}
                            </Link>
                        );
                    })}
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                    <Typography sx={{ paddingTop: 4 }}>
                        {t("welcomeDialog.anyFurtherQuestions")}{" "}
                        <Link href={"https://dokladovna.cz/kontakt/"} target={"_blank"}>
                            {t("welcomeDialog.links.getInTouchWithUs")}
                        </Link>
                    </Typography>
                    <Box sx={{ marginLeft: "auto", marginTop: 0.4 }}>
                        <Image src={require("../assets/woman_laptop.png")} height={115} width={115} />
                    </Box>
                </Box>
                <FormControlLabel onChange={handleChange} control={<Checkbox checked={isChecked} />} label={t("welcomeDialog.dontShowAgain")} />
            </Box>
        </TaxGuruDialog>
    );
};

export default WelcomeModal;
